import React from "react";

export default function HomeIcon({ className, size = 14, strokeWidth = 1.5, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...rest}
    >
      <path d="M6.846.75c.465 0 .922.139 1.55.499.648.371 1.41.938 2.496 1.746.588.438.994.74 1.293 1.004.292.256.44.44.536.618.2.375.22.807.22 2.196v1.02c0 1.405-.002 2.372-.116 3.098-.108.69-.304 1.059-.624 1.333-.337.288-.818.475-1.685.575-.88.101-2.039.102-3.67.102-1.632 0-2.791-.001-3.67-.102-.868-.1-1.349-.287-1.686-.575-.32-.274-.515-.643-.624-1.333C.752 10.205.75 9.238.75 7.833v-1.02c0-1.388.02-1.82.22-2.196.095-.179.244-.362.536-.618.3-.263.705-.566 1.293-1.004C3.884 2.187 4.646 1.62 5.294 1.25 5.922.889 6.38.75 6.846.75Z" />
    </svg>
  );
}
